const INBOUND_BASE_URL = process.env.REACT_APP_INBOUND_API_BASE_URL;
const JIT_ENDPOINT = '/program-coverage/stock/';
const JIT_FILTERS_ENDPOINT = '/program-coverage/stock/filters';
const COMMENT_ENDPOINT = '/comment';
const JIT_TRANISTS = '/program-coverage/transits';
const JIT_LOADS = '/program-coverage/loads';
const REMARK = '/program-coverage/remark';
const M100 = '/program-coverage/m100';
const STOCK_STATUS = '/program-coverage/stock-status';
const API_GET_STOCK_JIT_BY_PROVIDER = (providerName: string) =>
  `${INBOUND_BASE_URL}${JIT_ENDPOINT}${providerName}`;
const API_GET_JIT_FILTERS = `${INBOUND_BASE_URL}${JIT_FILTERS_ENDPOINT}`;
const API_GET_JIT_PR_FILTER = `${INBOUND_BASE_URL}${JIT_ENDPOINT}prs`;
const API_DOWNLOAD_JIT_COVERAGE_PARTS = (providerName: string) =>
  `${INBOUND_BASE_URL}${JIT_ENDPOINT}${providerName}/download`;
const API_PUT_COMMENT = (code: string) =>
  `${INBOUND_BASE_URL}/program-coverage/${code}${COMMENT_ENDPOINT}`;
const API_GET_TRANSIT_BY_PIECE = `${INBOUND_BASE_URL}${JIT_LOADS}`;
const API_DELETE_TRANSIT_BY_ID = `${INBOUND_BASE_URL}${JIT_TRANISTS}`;
const API_EDIT_TRANSITS = `${INBOUND_BASE_URL}${JIT_TRANISTS}`;
const API_TRANSITS = `${INBOUND_BASE_URL}${JIT_TRANISTS}`;

const API_REMARKS = `${INBOUND_BASE_URL}${REMARK}`;
const API_DELETE_REMARK_BY_ID = `${INBOUND_BASE_URL}${JIT_TRANISTS}`;
const API_EDIT_REMARK = `${INBOUND_BASE_URL}${JIT_TRANISTS}`;

const API_M100 = `${INBOUND_BASE_URL}${M100}`;

const API_STOCK_STTATUS = `${INBOUND_BASE_URL}${STOCK_STATUS}`;

export {
  API_GET_STOCK_JIT_BY_PROVIDER,
  API_GET_JIT_FILTERS,
  API_GET_JIT_PR_FILTER,
  API_DOWNLOAD_JIT_COVERAGE_PARTS,
  API_PUT_COMMENT,
  API_GET_TRANSIT_BY_PIECE,
  API_DELETE_TRANSIT_BY_ID,
  API_EDIT_TRANSITS,
  API_REMARKS,
  API_DELETE_REMARK_BY_ID,
  API_EDIT_REMARK,
  API_TRANSITS,
  API_M100,
  API_STOCK_STTATUS
};
